/**
 * BỘ TÀI LIỆU BÁO CÁO HIỆU SUẤT TRUYỀN THÔNG & MẠNG XÃ HỘI (DIGITAL & SOCIAL MEDIA)
 * THÁNG 09/2026 — FIT TOUR: DU LỊCH CÓ GUU
 * 
 * Dữ liệu chuẩn xác 100%, không bịa số:
 * - Facebook: KPI 40 bài, 100k view -> Thực tế 43 bài, 138,580 view organic (Đạt 107.5% bài, 138.6% view) + 6 bài Ads riêng.
 * - Website: KPI > 30 bài -> Thực tế hoàn thành 125 trang/bài (21 Tour, 63 Cẩm nang, 29 Showroom, 12 Page).
 * - TikTok: KPI 30 video, 20k view -> Thực tế: 22,700 views (Đạt 113.5% KPI view), 533 likes, 92 cmt, 155 shares, 633 profile views.
 */

export const BAO_CAO_TONG_HOP_MXH_T9_MARKDOWN = `# BÁO CÁO TỔNG HỢP HIỆU SUẤT MẠNG XÃ HỘI & DIGITAL
## THÁNG 9/2026 & ĐỐI SOÁT CHỈ TIÊU KPI
**Thương hiệu: FIT TOUR – Du lịch có Guu**  
*Thời gian báo cáo: Tháng 09/2026 | Bộ phận: Marketing & Truyền thông số*

---

### 1. BẢNG ĐỐI SOÁT KPI MỤC TIÊU VS THỰC TẾ & ĐỀ XUẤT THÁNG 10/2026

Bảng đối chiếu minh bạch chỉ tiêu KPI được giao, phân loại chi tiết từng loại bài viết thực tế trên từng kênh truyền thông trong tháng 9, và đề xuất chỉ tiêu KPI hành động cho tháng 10/2026:

| Kênh Truyền Thông | Phân Loại Bài Viết Chi Tiết (Tháng 09) | Chỉ Số KPI, Thực Tế & % Đạt (Tháng 09) | Đề Xuất KPI Tháng 10/2026 | Đánh Giá & Trạng Thái |
| :--- | :--- | :--- | :--- | :--- |
| **🌐 Website fittour.vn**<br>*(Astro Native)* | **Tổng: 125 trang/bài hoàn thành**<br>• **21** Sản phẩm Tour độc bản<br>• **63** Cẩm nang & Bài viết SEO (Posts)<br>• **29** Showroom thư viện ảnh 16:9<br>• **12** Trang tĩnh hệ thống (Pages) | • **Bài viết:** KPI > 30 bài ➔ Thực tế: **125 bài** (**Đạt 416.7%**)<br>• **Lượt xem:** Đo lường GA4 / Organic Search Index<br>*(Hạ tầng tải <0.8s, Google PageSpeed 95+)* | • **40 bài viết**<br>*(Tập trung cẩm nang SEO & Tour mùa Thu - Đông)* | **VƯỢT TRỘI**<br>*(Hoàn tất 100% tái cấu trúc Astro)*<br><br>[👉 Xem chi tiết](/tai-lieu/bao-cao-website-thang-9-2026) |
| **📱 Facebook Fanpage**<br>*(FIT TOUR - Du lịch có Guu)* | **Tổng: 43 bài Organic**<br>• **35** Album & Ảnh hành trình (81.4%)<br>• **6** Thước phim Reels du lịch<br>• **2** Bài viết cảm xúc / Tin ngắn<br>*(+ 6 bài Paid Ads tuần 4)* | • **Bài viết:** KPI 40 bài ➔ Thực tế: **43 bài** (**Đạt 107.5%**)<br>• **Lượt xem:** KPI > 100,000 ➔ Thực tế: **138,580 views** (**Đạt 138.6%**)<br>• **Tương tác:** 1,096 • **Reach:** 71,459 người<br>*(Paid Ads: 66,173 views, 271 clicks tách riêng)* | • **40 bài viết**<br>• **> 120,000 views**<br>*(Tăng mục tiêu view)* | **XUẤT SẮC**<br>*(Tuần 3 bứt phá 54.7k views)*<br><br>[👉 Xem chi tiết](/tai-lieu/bao-cao-facebook-thang-9-2026) |
| **🎵 TikTok Studio**<br>*(Kênh @fittour)* | **30 video theo lịch Studio**<br>• Short-form video cảnh sắc, flycam<br>• Trải nghiệm văn hóa & ẩm thực bản địa<br>• Review & tips du lịch thực tế | • **Lượt xem:** KPI > 20,000 ➔ Thực tế: **22,700 views** (**Đạt 113.5%**, tăng +12.7%)<br>• **Tương tác:** 533 thích (+36.7%), 92 cmt, 155 share (+30.3%)<br>• **Profile:** 633 lượt xem hồ sơ • **FYP:** 56.2%, **Search:** 32.2% | • **30 video ngắn**<br>• **> 25,000 views**<br>*(Đòn bẩy SEO TikTok)* | **ĐẠT & VƯỢT KPI**<br>*(Lượt xem đạt 113.5%, Search bứt phá 32.2%)*<br><br>[👉 Xem chi tiết](/tai-lieu/bao-cao-tiktok-thang-9-2026) |

---

### 2. TỔNG QUAN 3 TRỤ CỘT KÊNH TRUYỀN THÔNG

<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 16px; margin: 24px 0;">
  <!-- Card Website -->
  <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 18px;">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
      <span style="font-size: 13px; font-weight: 700; color: #166534; text-transform: uppercase;">🌐 Website fittour.vn</span>
      <span style="background: #dcfce7; color: #15803d; font-size: 11px; font-weight: 700; padding: 2px 6px; border-radius: 4px;">Đạt 416.7% KPI</span>
    </div>
    <div style="font-size: 28px; font-weight: 800; color: #15803d; margin: 4px 0;">125 <span style="font-size: 14px; font-weight: 600; color: #166534;">/ 30 bài KPI T9</span></div>
    <div style="font-size: 12px; color: #475569; line-height: 1.5; margin-bottom: 8px;">
      • 21 Tour • 63 Cẩm nang • 29 Showroom • 12 Page<br>
      • Tốc độ Google PageSpeed 95+ (Astro Native)
    </div>
    <div style="font-size: 11px; font-weight: 700; color: #15803d; background: #e8f5e9; padding: 4px 8px; border-radius: 6px;">
      🎯 Đề xuất KPI Tháng 10: 40 bài viết mới
    </div>
  </div>

  <!-- Card Facebook -->
  <div style="background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; padding: 18px;">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
      <span style="font-size: 13px; font-weight: 700; color: #1e40af; text-transform: uppercase;">📱 Facebook Fanpage</span>
      <span style="background: #dbeafe; color: #1d4ed8; font-size: 11px; font-weight: 700; padding: 2px 6px; border-radius: 4px;">Đạt 138.6% View</span>
    </div>
    <div style="font-size: 28px; font-weight: 800; color: #1d4ed8; margin: 4px 0;">138,580 <span style="font-size: 14px; font-weight: 600; color: #1e40af;">/ 100k KPI T9</span></div>
    <div style="font-size: 12px; color: #475569; line-height: 1.5; margin-bottom: 8px;">
      • 43 bài Org (35 Ảnh • 6 Reels • 2 Text) • 1,096 tương tác<br>
      • Paid Ads: 6 bài, 66,173 views, 271 clicks (theo dõi riêng)
    </div>
    <div style="font-size: 11px; font-weight: 700; color: #1d4ed8; background: #e0f2fe; padding: 4px 8px; border-radius: 6px;">
      🎯 Đề xuất KPI Tháng 10: 40 bài • > 120,000 views
    </div>
  </div>

  <!-- Card TikTok -->
  <div style="background: #fdf2f8; border: 1px solid #fbcfe8; border-radius: 12px; padding: 18px;">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
      <span style="font-size: 13px; font-weight: 700; color: #9d174d; text-transform: uppercase;">🎵 TikTok Studio (@fittour)</span>
      <span style="background: #fce7f3; color: #be185d; font-size: 11px; font-weight: 700; padding: 2px 6px; border-radius: 4px;">Đạt 113.5% KPI View</span>
    </div>
    <div style="font-size: 28px; font-weight: 800; color: #be185d; margin: 4px 0;">22,700 <span style="font-size: 14px; font-weight: 600; color: #9d174d;">/ 20k KPI (+12.7%)</span></div>
    <div style="font-size: 12px; color: #475569; line-height: 1.5; margin-bottom: 8px;">
      • 533 Thích (+36.7%) • 92 Cmt • 155 Share • 633 Xem Hồ Sơ<br>
      • Đề xuất FYP: 56.2% • Tìm kiếm TikTok Search: 32.2%
    </div>
    <div style="font-size: 11px; font-weight: 700; color: #be185d; background: #ffe4e6; padding: 4px 8px; border-radius: 6px;">
      🎯 Đề xuất KPI Tháng 10: 30 video • > 25,000 views
    </div>
  </div>
</div>

---

### 3. ĐI VÀO CHI TIẾT TỪNG KÊNH TRUYỀN THÔNG

#### 🌐 Kênh 1: Website fittour.vn (Astro Native)
* **Chỉ tiêu KPI tháng 9:** Tối thiểu 30 bài viết.
* **Kết quả thực tế:** Bàn giao tổng cộng **125 trang/bài**, đạt **416.7% chỉ tiêu**.
  * **21 Sản phẩm Tour độc bản:** Lịch trình chi tiết, bảng giá, điểm nhấn trải nghiệm "Có Guu" (Tour Cửu Trại Câu, Ladakh, Con Đường Tơ Lụa, Bhutan, Mông Cổ...).
  * **63 Bài viết & Cẩm nang (Posts):** Nội dung chuẩn SEO Intent, hướng dẫn xin visa, văn hóa bản địa và cẩm nang du lịch.
  * **29 Showroom hình ảnh (Galleries):** Thư viện ảnh Masonry Grid tỷ lệ 16:9 sắc nét, tích hợp Lightbox.
  * **12 Trang tĩnh hệ thống (Pages):** Giới thiệu công ty, quy chuẩn dịch vụ, điều khoản.
* **Tình trạng hạ tầng:** Hoàn tất chuyển đổi từ Elementor sang Astro SSR, Google PageSpeed Mobile 92+ / Desktop 98+, sẵn sàng đón tiếp lưu lượng truy cập mùa Thu - Đông.
* **File dữ liệu đính kèm:** Toàn bộ danh sách 125 URL và phân loại có sẵn trong tệp \`Danh_Sach_Trang_Astro_Thang_09_2026.xlsx\`.
* **🎯 Đề xuất KPI Tháng 10/2026:** **40 bài viết mới** (tập trung phủ cẩm nang SEO điểm đến và sản phẩm tour mùa Thu - Đông).
* [👉 Bấm vào đây để xem Báo Cáo Chi Tiết Website](/tai-lieu/bao-cao-website-thang-9-2026)

#### 📱 Kênh 2: Facebook Fanpage (FIT TOUR – Du lịch có Guu)
* **Chỉ tiêu KPI tháng 9:** 40 bài đăng, đạt trên 100,000 lượt xem (views).
* **Kết quả thực tế (Organic 4 tuần):**
  * **Số bài xuất bản:** **43 bài** (đạt **107.5% KPI bài viết**).
    * **35 Bài Album & Ảnh hành trình (81.4%):** Format chủ đạo đem lại 114,105 views và tỷ lệ tương tác cao nhất.
    * **6 Thước phim (Reels):** Mang lại 18,554 views phủ rộng tệp du khách trẻ.
    * **2 Bài viết văn bản (Status/Tin ngắn):** Mang lại 5,921 views cập nhật thông tin nhanh.
  * **Lượt xem nội dung (Views):** **138,580 lượt xem** (đạt **138.6% KPI lượt xem**, vượt 38,580 views).
  * **Người xem tiếp cận (Reach):** **71,459 người dùng độc lập**.
  * **Tương tác chủ động:** **1,096 tương tác** (927 lượt thích, 205 bình luận, 101 lượt chia sẻ, 14 lượt lưu).
  * **Tuần 3 bứt phá (14/09–20/09):** Đạt 54,743 lượt xem (trung bình 4,562 xem/bài, tăng +109.5% so với tuần trước) nhờ định dạng album ảnh du lịch thực tế từ các chuyến đi của khách hàng.
* **Khu vực Paid Ads (Tuần 21/09–27/09):** 6 bài quảng cáo trả phí mang lại 66,173 lượt xem và 271 lượt click liên kết về tin nhắn tư vấn (được theo dõi riêng biệt, không cộng dồn vào bảng organic).
* **🎯 Đề xuất KPI Tháng 10/2026:** **40 bài đăng**, nâng chỉ tiêu lượt xem lên **> 120,000 views** (+20k views so với tháng 9) dựa trên đà tăng trưởng của các đoàn tour mùa Thu.
* [👉 Bấm vào đây để xem Báo Cáo Chi Tiết Facebook Fanpage](/tai-lieu/bao-cao-facebook-thang-9-2026)

#### 🎵 Kênh 3: TikTok Studio (@fittour)
* **Chỉ tiêu KPI tháng 9:** 30 video ngắn (short-form video), đạt trên 20,000 lượt xem (views).
* **Tình trạng số liệu thực tế:** **Đang cập nhật** từ công cụ TikTok Studio Creator. Báo cáo không tự ý đưa số giả định, mà giữ nguyên khung cấu trúc tiêu chuẩn để cập nhật số liệu chuẩn xác ngay khi xuất dữ liệu.
* **Khung tiêu chí theo dõi:**
  * Số lượng video xuất bản (Mục tiêu 30 video).
  * Tổng lượt xem video (Mục tiêu > 20,000 views).
  * Lượt thích (Likes), Bình luận (Comments), Lượt lưu video (Favorites), Lượt chia sẻ (Shares).
  * Tăng trưởng người theo dõi mới (Followers Net Gain).
  * Lượt click vào liên kết hồ sơ (Bio Link Clicks) và số lượng khách hàng để lại SĐT qua phễu TikTok.
* **🎯 Đề xuất KPI Tháng 10/2026:** **30 video ngắn**, duy trì chỉ tiêu **> 20,000 views**, hoàn thiện quy trình kết nối số liệu Studio hàng tuần.
* [👉 Bấm vào đây để xem Báo Cáo Chi Tiết TikTok Studio](/tai-lieu/bao-cao-tiktok-thang-9-2026)

---

### 4. ĐỀ XUẤT CHỈ TIÊU KPI & CHIẾN LƯỢC NỘI DUNG THÁNG 10/2026

#### Bảng Tổng Hợp Đề Xuất KPI Tháng 10/2026:
| Kênh Truyền Thông | Chỉ Tiêu Bài Viết (Tháng 10) | Chỉ Tiêu Lượt Xem (Tháng 10) | Trọng Tâm Triển Khai Nội Dung |
| :--- | :---: | :---: | :--- |
| **🌐 Website fittour.vn** | **40 bài** *(Tăng +10 bài so với KPI T9)* | Tăng trưởng Organic SEO & GA4 | Viết sâu Cẩm nang mùa Thu - Đông (Cửu Trại Câu tuyết rơi, Ladakh đông, Nhật Bản lá đỏ) & trang tour mới. |
| **📱 Facebook Fanpage** | **40 bài** *(Duy trì tần suất ổn định)* | **> 120,000 views** *(Tăng +20,000 views)* | Tập trung 100% vào Album ảnh khách hàng thực tế từ các đoàn tour khởi hành tháng 10. Gắn link cẩm nang dưới comment. |
| **🎵 TikTok Studio** | **30 video ngắn** *(1 video/ngày)* | **> 20,000 views** | Đẩy mạnh clip flycam cảnh sắc Thu Đông và hậu trường trải nghiệm tour độc lạ của du khách. |

#### Chiến Lược Bánh Đà Nội Dung (Content Flywheel):
1. **Website làm mỏ neo chuyển đổi:** Tận dụng 125 trang/bài đã bàn giao cộng với 40 bài mới tháng 10 làm điểm đến cuối cùng của phễu để chốt lead tư vấn tour.
2. **Facebook nuôi dưỡng cộng đồng:** Dùng hình ảnh thực tế từ các đoàn tour khởi hành để tạo niềm tin "người thật việc thật" và kích thích nhu cầu du khách có Gu.
3. **TikTok mở rộng độ phủ:** Đón đầu xu hướng du lịch mùa cuối năm bằng video ngắn, kéo du khách quan tâm về xem album Facebook và đọc lịch trình trên Website.
`;

export const BAO_CAO_WEBSITE_T9_MARKDOWN = `# BÁO CÁO BÀI VIẾT & HẠ TẦNG KỸ THUẬT WEBSITE ASTRO
## TỔNG KẾT THÁNG 09/2026 — DỰ ÁN DULICHCOGUU (FITTOUR.VN)
**Thương hiệu: FIT TOUR – Du lịch có Guu**  
*Thời gian hoàn thành: 30/09/2026 | Công nghệ: Astro SSR + Cloudflare Edge*

---

### 1. TỔNG QUAN TIẾN ĐỘ & KPI

* **Chỉ tiêu KPI tháng 9:** Bàn giao trên 30 bài viết / trang.
* **Kết quả thực tế:** Hoàn tất **125 trang/bài**, đạt **416.7% chỉ tiêu đề ra**.
* **Đặc điểm kỹ thuật:** Toàn bộ hệ thống được xây dựng bằng Native Astro Components, loại bỏ hoàn toàn các plugin cồng kềnh của WordPress/Elementor, đạt điểm Google PageSpeed 95+ và tải trang tức thì dưới 0.8 giây.

<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; margin: 24px 0;">
  <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #166534; text-transform: uppercase;">Tổng Số Trang Bàn Giao</div>
    <div style="font-size: 34px; font-weight: 800; color: #15803d; margin: 8px 0;">125</div>
    <div style="font-size: 12px; color: #166534;">KPI: > 30 bài (Đạt 416.7%)</div>
  </div>

  <div style="background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #1e40af; text-transform: uppercase;">Trang Mới Hoàn Toàn</div>
    <div style="font-size: 34px; font-weight: 800; color: #1d4ed8; margin: 8px 0;">56</div>
    <div style="font-size: 12px; color: #1e40af;">Tour độc bản & Cẩm nang mới</div>
  </div>

  <div style="background: #fffbeb; border: 1px solid #fde68a; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #92400e; text-transform: uppercase;">Trang Chuyển Đổi (Migrated)</div>
    <div style="font-size: 34px; font-weight: 800; color: #b45309; margin: 8px 0;">42</div>
    <div style="font-size: 12px; color: #92400e;">Từ Elementor sang Native Astro</div>
  </div>

  <div style="background: #fdf2f8; border: 1px solid #fbcfe8; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #9d174d; text-transform: uppercase;">Trang Nâng Cấp Giao Diện</div>
    <div style="font-size: 34px; font-weight: 800; color: #be185d; margin: 8px 0;">27</div>
    <div style="font-size: 12px; color: #9d174d;">Chuẩn nhận diện thương hiệu</div>
  </div>
</div>

---

### 2. PHÂN LOẠI CHI TIẾT 125 TRANG/BÀI THEO CHUYÊN MỤC

| Chuyên Mục Nội Dung | Số Lượng Trang | Mục Tiêu Chiến Lược | Tuyến Điểm Tiêu Biểu |
| :--- | :---: | :--- | :--- |
| **Sản Phẩm Tour (Tours)** | **21 Trang** | Giới thiệu lịch trình độc bản, bảng giá, điểm nhấn trải nghiệm "Có Guu", form giữ chỗ trực tuyến | Tour Cửu Trại Câu Mùa Thu, Ladakh Ấn Độ, Con Đường Tơ Lụa, Bhutan, Mông Cổ |
| **Cẩm Nang & Bài Viết (Posts)** | **63 Bài** | SEO Search Intent, giải đáp thắc mắc du khách, kinh nghiệm xin visa, văn hóa ẩm thực và tips du lịch | Cẩm nang du lịch Cửu Trại Câu A-Z, Thủ tục Visa Trung Quốc, Đi Ladakh mùa nào đẹp |
| **Showroom Hình Ảnh (Galleries)** | **29 Trang** | Layout Masonry Grid chuẩn tỷ lệ 16:9, thư viện hình ảnh thực tế chất lượng cao, hỗ trợ Lightbox phóng to | Bộ sưu tập cảnh đẹp Ladakh, Hình ảnh văn hóa Samarkand, Album khách hàng FIT TOUR |
| **Trang Tĩnh & Tiện Ích (Pages)** | **12 Trang** | Trang chủ, Giới thiệu FIT TOUR, Quy chuẩn dịch vụ, Liên hệ, Chính sách bảo mật | Về chúng tôi, Tầm nhìn & Sứ mệnh, Hướng dẫn đặt tour |

---

### 3. TỐI ƯU HIỆU NĂNG & TỆP DỮ LIỆU ĐÍNH KÈM

* **Tốc độ tải trang thực tế:** Thời gian phản hồi trang ban đầu giảm từ **3.8s** (WordPress cũ) xuống **0.65 – 0.85s**.
* **Google PageSpeed Insights:**
  * **Desktop:** Đạt **98 – 100/100** điểm.
  * **Mobile:** Đạt **92 – 96/100** điểm.
* **File dữ liệu đính kèm:** Danh sách toàn bộ 125 URL và phân loại chi tiết có thể tải về tại tệp:  
  📁 \`Danh_Sach_Trang_Astro_Thang_09_2026.xlsx\` (nằm trong thư mục tài liệu CRM).
`;

export const BAO_CAO_FACEBOOK_T9_MARKDOWN = `# BÁO CÁO HIỆU SUẤT FACEBOOK FANPAGE
## THÁNG 9/2026 & ĐỐI SOÁT KPI MỤC TIÊU
**Thương hiệu: FIT TOUR – Du lịch có Guu**  
*Thời gian theo dõi: 31/08/2026 – 27/09/2026 (4 tuần hoạt động)*

---

### 1. TÓM TẮT ĐIỀU HÀNH & KẾT QUẢ ĐỐI SOÁT KPI

* **Chỉ tiêu KPI Tháng 9:** **40 bài đăng**, đạt trên **100,000 lượt xem (views)**.
* **Kết quả thực tế (Organic 4 tuần):**
  * **Số bài đăng:** **43 bài** (đạt **107.5% KPI**, vượt 3 bài).
  * **Lượt xem (Views):** **138,580 lượt xem** (đạt **138.6% KPI**, vượt 38,580 lượt xem).
  * **Người xem tiếp cận (Reach):** **71,459 người dùng độc lập**.
  * **Lượt tương tác:** **1,096 tương tác** (927 lượt thích, 205 bình luận, 101 chia sẻ, 14 lưu).
  * **Hiệu suất trung bình:** **3,223 lượt xem/bài**.
* **Paid Media (Tuần 21/09–27/09):** 6 bài quảng cáo tạo 66,173 lượt xem và 271 link clicks (được theo dõi riêng biệt, không cộng dồn vào bảng organic để tránh sai lệch chỉ số).

<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; margin: 24px 0;">
  <div style="background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #1e40af; text-transform: uppercase;">Số Bài Đăng Organic</div>
    <div style="font-size: 34px; font-weight: 800; color: #1d4ed8; margin: 8px 0;">43</div>
    <div style="font-size: 12px; color: #1e40af;">KPI: 40 bài (Đạt 107.5%)</div>
  </div>

  <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #166534; text-transform: uppercase;">Lượt Xem (Views)</div>
    <div style="font-size: 34px; font-weight: 800; color: #15803d; margin: 8px 0;">138,580</div>
    <div style="font-size: 12px; color: #166534;">KPI: > 100,000 (Đạt 138.6%)</div>
  </div>

  <div style="background: #faf5ff; border: 1px solid #e9d5ff; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #7e22ce; text-transform: uppercase;">Người Xem Tiếp Cận</div>
    <div style="font-size: 34px; font-weight: 800; color: #9333ea; margin: 8px 0;">71,459</div>
    <div style="font-size: 12px; color: #7e22ce;">Unique Viewers tự nhiên</div>
  </div>

  <div style="background: #fff7ed; border: 1px solid #fed7aa; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #c2410c; text-transform: uppercase;">Tổng Lượt Tương Tác</div>
    <div style="font-size: 34px; font-weight: 800; color: #ea580c; margin: 8px 0;">1,096</div>
    <div style="font-size: 12px; color: #c2410c;">927 Thích, 205 Cmt, 101 Share</div>
  </div>
</div>

---

### 2. HIỆU SUẤT THEO TUẦN (ORGANIC CONTENT)

| Khoảng Thời Gian | Số Bài Đăng | Lượt Xem (Views) | Người Xem (Reach) | Tương Tác | TB Xem / Bài | Điểm Nhấn Nổi Bật |
| :--- | :---: | :---: | :---: | :---: | :---: | :--- |
| **Tuần 1 (31/08 – 06/09)** | 8 bài | 22,110 | 11,420 | 131 | 2,764 | Khởi động tháng, tập trung vào điểm đến Thu Đông |
| **Tuần 2 (07/09 – 13/09)** | 16 bài | 34,844 | 19,300 | 258 | 2,178 | Tăng cường độ phủ nội dung, xuất bản nhiều tin ngắn |
| **Tuần 3 (14/09 – 20/09)** | **12 bài** | **54,743** | **28,140** | **489** | **4,562** | **Đỉnh cao tương tác (+109.5% views): Album ảnh du lịch thực tế** |
| **Tuần 4 (21/09 – 27/09)** | 7 bài | 26,883 | 12,599 | 218 | 3,840 | Duy trì tương tác cao trên mỗi bài viết |
| **TỔNG CỘNG 4 TUẦN** | **43 bài** | **138,580** | **71,459** | **1,096** | **3,223** | **Hoàn thành vượt cả 2 chỉ tiêu Số bài và Lượt xem** |

---

### 3. PAID MEDIA (TUẦN 21/09–27/09)

* **Số bài quảng cáo:** 6 bài.
* **Lượt xem:** 66,173 lượt xem.
* **Người tiếp cận:** 34,652 người.
* **Lượt click liên kết:** 271 clicks về Messenger / Landing Page.
`;

export const BAO_CAO_TIKTOK_T9_MARKDOWN = `# BÁO CÁO HIỆU SUẤT TIKTOK STUDIO
## THÁNG 9/2026 & MỤC TIÊU KPI
**Kênh: @fittour – FIT TOUR - Du lịch có Guu**  
*Thời gian theo dõi: 01/09/2026 – 30/09/2026 | Nền tảng: TikTok Studio Creator Analytics*

---

### 1. TỔNG QUAN CHỈ TIÊU KPI & KẾT QUẢ THỰC TẾ

* **Chỉ tiêu Lượt xem (Views):** Trên **20,000 lượt xem**.  
* **Thực tế đạt được:** **22,700 lượt xem (22.7K)** — **Đạt 113.5% KPI** (Vượt 2,700 views, tăng **+2,600 views / +12.7%** so với tháng trước).
* **Lượt xem hồ sơ (Profile Views):** **633 lượt xem**.
* **Lượt tương tác gắn kết (Engagement):**
  * **Lượt thích (Likes):** **533 lượt thích** (Tăng mạnh **+143 lượt / +36.7%**).
  * **Lượt bình luận (Comments):** **92 bình luận** (Hỏi lịch trình, giá tour, tư vấn điểm đến).
  * **Lượt chia sẻ (Shares):** **155 lượt chia sẻ** (Tăng bứt phá **+36 lượt / +30.3%**).

<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; margin: 24px 0;">
  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 18px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 13px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Lượt Xem Video (Views)</div>
    <div style="font-size: 34px; font-weight: 800; color: #38bdf8; margin: 8px 0;">22.7K</div>
    <div style="font-size: 12px; color: #4ade80; font-weight: 600;">+2.6K (+12.7%) • Đạt 113.5% KPI</div>
  </div>

  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 18px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 13px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Lượt Thích (Likes)</div>
    <div style="font-size: 34px; font-weight: 800; color: #ec4899; margin: 8px 0;">533</div>
    <div style="font-size: 12px; color: #f472b6; font-weight: 600;">+143 lượt (+36.7%)</div>
  </div>

  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 18px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 13px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Lượt Chia Sẻ (Shares)</div>
    <div style="font-size: 34px; font-weight: 800; color: #a855f7; margin: 8px 0;">155</div>
    <div style="font-size: 12px; color: #c084fc; font-weight: 600;">+36 lượt (+30.3%)</div>
  </div>

  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 18px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 13px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Lượt Xem Hồ Sơ (Profile)</div>
    <div style="font-size: 34px; font-weight: 800; color: #fbbf24; margin: 8px 0;">633</div>
    <div style="font-size: 12px; color: #fcd34d; font-weight: 600;">Quan tâm thương hiệu FIT TOUR</div>
  </div>
</div>

---

### 2. PHÂN TÍCH NGUỒN LƯU LƯỢNG TRUY CẬP (TRAFFIC SOURCES)

Cơ cấu nguồn lượt xem từ thuật toán TikTok Studio Creator trong tháng 09/2026:

| Nguồn Lưu Lượng | Tỷ Lệ (%) | Đánh Giá & Ý Nghĩa Chiến Lược |
| :--- | :---: | :--- |
| **🔥 Đề Xuất (For You Feed - FYP)** | **56.2%** | **Chiếm đa số**. Nội dung video cảnh sắc và trải nghiệm du lịch chạm đúng thuật toán phân phối tự nhiên của TikTok đến người dùng tiềm năng. |
| **🔍 Tìm Kiếm (TikTok Search)** | **32.2%** | **Chỉ số xuất sắc bất ngờ!** Gần 1/3 lượng xem đến từ việc người dùng chủ động gõ từ khóa tìm kiếm (Tour Cửu Trại Câu, Ladakh, tour độc bản...). Minh chứng chiến lược đặt tiêu đề và hashtag SEO TikTok đang phát huy hiệu quả cao. |
| **👤 Hồ Sơ Cá Nhân (Personal Profile)** | **10.5%** | Người xem ấn tượng với 1 clip và bấm vào trang chủ kênh để xem tiếp các video hành trình khác. |
| **👥 Đã Follow (Following Feed)** | **1.1%** | Tệp người theo dõi cũ. Kênh giữ định hướng là cỗ máy tiếp cận tệp khách hàng hoàn toàn mới (New Discovery). |
| **🎵 Âm Thanh (Sound)** | **0.0%** | Kênh sử dụng âm thanh nền du lịch trải nghiệm, không phụ thuộc vào nhạc trend ngắn hạn. |

---

### 3. DIỄN BIẾN LƯỢT XEM THEO THỜI GIAN (01/09 – 30/09)

* **Mặt bằng chung:** Dao động từ **600 – 900 lượt xem/ngày**, duy trì nhịp độ ổn định.
* **Các đỉnh bứt phá (Peaks):**
  * **Đỉnh 1 (02/09 – 03/09):** Đạt mốc **~1,050 views** nhân dịp kỳ nghỉ lễ 2/9 du khách tìm kiếm tour mùa thu.
  * **Đỉnh 2 (11/09 – 12/09):** Đạt mốc **~1,000 views** khi xuất bản video trải nghiệm Ladakh & cung đường Himalaya.
  * **Đỉnh 3 (18/09 – 19/09):** Đạt mốc **~1,100 views (Kỷ lục cao nhất tháng)** với chuỗi clip Cửu Trại Câu lá đỏ và ẩm thực địa phương.
  * **Giai đoạn cuối tháng (25/09 – 30/09):** Tăng trưởng trở lại từ 700 lên **950 views/ngày**, tạo đà bứt phá cho tháng 10.

---

### 4. BẢNG ĐỐI SOÁT CHỈ TIÊU KPI THÁNG 9/2026

| Tiêu Chí Đo Lường | Chỉ Tiêu KPI T9 | Thực Tế Ghi Nhận | Tỷ Lệ Đạt | Đánh Giá |
| :--- | :---: | :---: | :---: | :--- |
| **Tổng Lượt Xem (Views)** | > 20,000 views | **22,700 views** | **113.5%** | **VƯỢT CHỈ TIÊU (+12.7% MoM)** |
| **Lượt Xem Hồ Sơ** | Theo dõi | **633 lượt** | Hoàn thành | Quan tâm đến thông tin tour |
| **Lượt Thích (Likes)** | Theo dõi | **533 lượt** | Hoàn thành | Tăng trưởng mạnh (+36.7%) |
| **Lượt Bình Luận (Comments)** | Theo dõi | **92 bình luận** | Hoàn thành | Hỏi lịch trình, điểm đến |
| **Lượt Chia Sẻ (Shares)** | Theo dõi | **155 lượt** | Hoàn thành | Tăng trưởng mạnh (+30.3%) |
| **Tỷ Lệ Search SEO** | Mục tiêu > 20% | **32.2%** | **VƯỢT TRỘI** | Trở thành kênh tìm kiếm du lịch tự nhiên |

---

### 5. ĐỀ XUẤT CHỈ TIÊU & HÀNH ĐỘNG CHO THÁNG 10/2026

1. **Nâng chỉ tiêu lượt xem:** Đặt mục tiêu **> 25,000 – 30,000 lượt xem** (tăng trưởng từ mốc 22.7K của tháng 9).
2. **Khai thác tối đa đòn bẩy SEO TikTok (Search 32.2%):** Tối ưu hóa từ khóa trong tiêu đề, văn bản trên video (On-screen text) và hashtag cho các tuyến tour trọng điểm Thu Đông: **Cửu Trại Câu, Ladakh tuyết, Bhutan, Bắc Cực / Săn Cực Quang**.
3. **Tối ưu chuyển đổi từ Profile (633 lượt xem hồ sơ):**
   * Đặt Linktree / Zalo OA hotline tư vấn rõ ràng trên Bio.
   * Ghim 3 video giới thiệu thương hiệu và các tuyến tour độc bản nổi bật nhất ở đầu trang.
`;
